import script from "./AddStoreView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddStoreView.vue?vue&type=script&lang=ts&setup=true"

import "./AddStoreView.vue?vue&type=style&index=0&id=5265014c&lang=css"

const __exports__ = script;

export default __exports__